import script from "./CompSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSummary.vue?vue&type=script&setup=true&lang=js"

import "./CompSummary.vue?vue&type=style&index=0&id=57b48230&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b48230"]])

export default __exports__